import styled from 'styled-components'
import { Card } from '@mtsdengi/common'

const CardWrapper = styled(Card)`
  overflow: visible;
`

export const Styled = {
  CardWrapper,
}
